import { FixedColState } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import { selectionColWidth } from "src/components/ReactiveTable/constants";
import {
  RtColumn,
  RtColumnFixedSide,
} from "src/components/ReactiveTable/RtColumn";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";

/**
 * Вычисляет позиции и информацию о фиксированных колонках
 */
export const calculateFixedColumns = <TRow extends AbstractRow>(
  fixedColumns: ReadonlyMap<string, RtColumnFixedSide>,
  columns: RtColumn<TRow>[],
  columnWidths: Record<string, number | string>,
  hasSelection: boolean,
): Map<string, FixedColState> => {
  const result = new Map<string, FixedColState>();
  const getColumnWidth = (key: string): number =>
    parseFloat(String(columnWidths[key] ?? 0));

  let leftPosition = hasSelection ? selectionColWidth : 0;
  columns.forEach(({ key }) => {
    if (fixedColumns.get(key) !== "left") return;
    result.set(key, { side: "left", pos: leftPosition });
    leftPosition += getColumnWidth(key);
  });

  let rightPosition = 0;
  columns
    .slice()
    .reverse()
    .forEach(({ key }) => {
      if (fixedColumns.get(key) !== "right") return;
      result.set(key, { side: "right", pos: rightPosition });
      rightPosition += getColumnWidth(key);
    });

  return result;
};
